export default __webpack_public_path__ + "static/media/mccia.b4449511.svg";